module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-to-bottom-edefdc231da4d9989e963bf6548dd135.svg";